import React from 'react';
import PropTypes from 'prop-types';

import { numberWithCommas } from 'utils/numberFormatter';

const GoalBar = ({ count, goal }) => {
  let percentage = ((count/goal)*100).toFixed(2);
  percentage = percentage > 100? 100: percentage;

  return (
    <div className="progress rounded-0 metrics-goal">
      <div className="metrics-status">
        <span>Goal: {numberWithCommas(goal)}</span>
        <span className="float-right">{percentage}%</span>
      </div>
      <div className="progress-bar" style={{width: `${percentage}%`}} role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>
  );
};

GoalBar.propTypes = {
  count: PropTypes.number.isRequired,
  goal: PropTypes.number.isRequired,
}

GoalBar.defaultProps = {
  count: 0,
  goal: 1,
}

export default GoalBar;


// WEBPACK FOOTER //
// ./src/components/dashboard/number/GoalBar.js